import React, { useState, useCallback } from 'react';
import { Form, Button } from 'react-bootstrap';
import { addExpense } from '../firebase/firebaseOps';
import { useAuth } from '../context/AuthContext';
import './ExpenseForm.css';
import useConfig from '../hooks/useConfig';
import { SpanError, SpanMessage } from './Elements';

const ExpenseForm = () => {
    const [formData, setFormData] = useState({
        amount: '',
        category: '',
        date: new Date(),
        place: '',
    });
    const [error, setError] = useState('');
    const [disabled, setDisable] = useState(false);
    const [message, setMessage] = useState('');
    const config = useConfig();
    const { usuario } = useAuth();

    const handleChange = useCallback((e) => {
        const { name, value } = e.target;
        setError('');
        setDisable(false);
        setMessage('');
        setFormData((prevData) => ({
            ...prevData,
            [name]: name === 'amount' ? value.replace(/[^0-9.]/g, '') : value,
        }));
    }, []);

    const handleSubmit = useCallback(async (e) => {
        e.preventDefault();
        setError('');
        setDisable(true);
        const { amount, category, date, place } = formData;

        if (!amount || !category || !date || !place) {
            setError('Todos los campos son obligatorios');
            setDisable(false);
            return false;
        }
        if (isNaN(amount)) {
            setError('El monto debe ser un número');
            setDisable(false);
            return false;
        }

        try {
            await addExpense(amount, category, date, place, usuario.uid);
            setFormData({
                amount: '',
                category: '',
                date: new Date(),
                place: '',
            });
            setError('');
            setDisable(false);
            setMessage('Gasto guardado exitosamente!');
        } catch (error) {
            setDisable(true);
            setError('Error al guardar el gasto');
        }
    }, [formData, usuario]);

    return (
        <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formPlace">
                <Form.Control 
                    type='text' 
                    name="place" 
                    size='lg' 
                    onChange={handleChange} 
                    value={formData.place}
                />
            </Form.Group>
            <Form.Group controlId="formAmount">
                <Form.Control
                    type="tel"
                    placeholder="₡0.00"
                    name="amount"
                    value={formData.amount}
                    onChange={handleChange}
                />
            </Form.Group>
            <Form.Group controlId="formCategory">
                <Form.Select name="category" size='lg' onChange={handleChange} value={formData.category}>
                    <option value="" disabled>Categoría</option>
                    {config && config[0]?.categories?.map((e, idx) => (
                        <option key={idx} value={e}>{e}</option>
                    ))}
                </Form.Select>
            </Form.Group>
            <Form.Group controlId="formDate">
                <Form.Control
                    type="date"
                    name="date"
                    value={formData.date.toISOString().split('T')[0]}
                    onChange={(e) => setFormData((prevData) => ({
                        ...prevData,
                        date: new Date(e.target.value),
                    }))}
                />
            </Form.Group>
            <Form.Group>
                {error ? <SpanError><strong>{error}</strong></SpanError> : <SpanMessage><strong>{message}</strong></SpanMessage>}
            </Form.Group>
            <Button variant="primary" type="submit" className="button-submit" disabled={disabled}>
                Guardar
            </Button>
        </Form>
    );
};

export default ExpenseForm;
